import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityShippingListApi } from 'api';

export const findEntityShippingList = createAsyncThunk(
  'entityShipping/findEntityShippingList',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityShippingListApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityShippingList = createAsyncThunk(
  'entityShipping/createEntityShippingList',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityShippingListApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityShippingList = createAsyncThunk(
  'entityShipping/findOneEntityShippingList',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityShippingListApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityShippingList = createAsyncThunk(
  'entityShipping/updateEntityShippingList',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityShippingListApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityShippingList = createAsyncThunk(
  'entityShipping/deleteEntityShippingList',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityShippingListApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  entityShippings: Array<any>;
  isFirstLoading: boolean;
  reloadFlag: boolean;
}

const initialState: IState = {
  entityShippings: [],
  isFirstLoading: false,
  reloadFlag: false,
};

const entityShippingListSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    reloadEntityShippingList(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityShippingList.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.entityShippings = newData;
      state.isFirstLoading = true;
    });
    builder.addCase(createEntityShippingList.fulfilled, (state, action) => {
      const { payload } = action;
      state.entityShippings = [payload, ...state.entityShippings];
    });
    builder.addCase(updateEntityShippingList.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.entityShippings = state.entityShippings.map((item: any) =>
        item.id == data.id ? data : item
      );
    });
  },
});

const { actions, reducer: entityShippingListReducer } = entityShippingListSlice;

export const { reloadEntityShippingList } = actions;

export default entityShippingListReducer;
